<div class="ledger-unresolved">
  <p class="intro">
    These payments came from the legacy system with a payment code that hasn't been mapped to an RMS payment method yet.
    They stay visible as "Legacy Unresolved" until Accounting approves the mapping.
  </p>

  @if (Loading) {
  <p class="muted" role="status">Loading unresolved payment codes…</p>
  } @else {
  <div class="summary-cards">
    <div class="summary-card">
      <div class="summary-label">Unresolved payments</div>
      <div class="summary-value">{{ TotalPayments | number }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Payment amount</div>
      <div class="summary-value">{{ TotalAmount | currency:'USD' }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Ledger entries</div>
      <div class="summary-value">{{ (Ledger?.LedgerRowCount ?? 0) | number }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Ledger net amount</div>
      <div class="summary-value">{{ (Ledger?.NetAmount ?? 0) | currency:'USD' }}</div>
    </div>
  </div>

  <rms-table [data]="Groups"
             [columns]="Columns"
             tableId="ledger-unresolved"
             startSort="PaymentCount"
             startSortDirection="desc">
  </rms-table>
  }
</div>
